import { render, staticRenderFns } from "./CourseShow.vue?vue&type=template&id=774f8ef4"
import script from "./CourseShow.vue?vue&type=script&lang=ts"
export * from "./CourseShow.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports